import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { FaInstagram, FaRegClosedCaptioning } from 'react-icons/fa';
import { FiSmartphone } from 'react-icons/fi';
import { GiDigitalTrace } from 'react-icons/gi';
import { HiOutlineMail } from 'react-icons/hi';
import { MdDesktopWindows } from 'react-icons/md';
import { VscFileMedia } from 'react-icons/vsc';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import NewFormWizard from '../../../components/formWizard/NewFormWizard';
import Layout from '../../../components/layouts/Layout';
import { eventOptionItems } from './slice/createEventSlice';
import { BsAspectRatio } from 'react-icons/bs';
import http from '../../../config/BaseUrl';
import { LoadingSpinner } from '../../../components/Loader/Loader';
import { ImFilm, ImQrcode } from 'react-icons/im';
import LocalStorage from '../../../hook/LocalStorage';
import { AiOutlineFileGif, AiFillEdit } from 'react-icons/ai';
import { IoMdGift } from 'react-icons/io';
import { getPackagePermissions } from '../packageAccess';

const EventOption = () => {
    const dispatch = useDispatch()
    const history = useHistory();

    const { user } = LocalStorage()
    const membershipPackageId = user?.membership?.package_id ?? user?.membership?.our_package?.id


    // const eventId = history.location.state
    const [packageTypes, setPackageTypes] = useState(null)
    const [adminPassword, setAdminPassword] = useState(new Array(4).fill(""));
    const [emailTemplateErr, setTemplateErr] = useState(false)
    const { event_option, feature, eventId } = useSelector(state => state.createEvent)
    const [loading, setLoading] = useState(false)
    const [draftLoading, setDraftLoading] = useState(false)
    const [packageAccessStatus, setPackageAccessStatus] = useState("loading")
    const [packageRequestKey, setPackageRequestKey] = useState(0)
    const [submitError, setSubmitError] = useState("")
    const packageLoading = packageAccessStatus === "loading"

    const { register, handleSubmit } = useForm({
        defaultValues: {
            filters: event_option.filters,
            digital_props: event_option.digital_props,
            data_capture: event_option.data_capture,
            social_media: event_option.social_media,
            email: event_option.email,
            frame_option: event_option.frame_option,
            video_frame_option: event_option.video_frame_option,
            boomerang_frame_option: event_option.boomerang_frame_option,
            water_mark: event_option.water_mark,
            text_messaging: event_option.text_messaging,
            gif: event_option.gif,
            brust_gif: event_option.brust_gif,
            microsite: event_option.microsite,
            incentive_offer: event_option.incentive_offer,
            qr_code: event_option.qr_code,
            form_builder: event_option.form_builder,
        },
        mode: "all",
        reValidateMode: "onChange"
    })

    useEffect(() => {
        if (event_option) {
            if (event_option.adminPassword) {
                let CreateArr = Object.assign([], event_option.adminPassword);
                setAdminPassword(CreateArr)
            }
        }
    }, [event_option])

    useEffect(() => {
        let mounted = true

        const loadPackagePermissions = async () => {
            setPackageAccessStatus("loading")
            setPackageTypes(null)

            try {
                const res = await http.get('/package-type')
                const permissions = getPackagePermissions(
                    res?.data?.packageType,
                    membershipPackageId
                )

                if (mounted) {
                    setPackageTypes(permissions)
                    setPackageAccessStatus(
                        Object.values(permissions).some(permission => permission === null)
                            ? "partial"
                            : "ready"
                    )
                }
            } catch (error) {
                if (mounted) {
                    setPackageTypes(null)
                    setPackageAccessStatus("error")
                }
            }
        }

        loadPackagePermissions()

        return () => {
            mounted = false
        }
    }, [membershipPackageId, packageRequestKey])

    const hasPackageAccess = (permission) => (
        (packageAccessStatus === "ready" || packageAccessStatus === "partial") &&
        packageTypes?.[permission] === true
    )

    const getPackageAccessMessage = (permission) => {
        if (packageAccessStatus === "loading") return "Checking package access..."
        if (packageAccessStatus === "error") return "Unable to verify package access"
        if (packageTypes?.[permission] === null || packageTypes?.[permission] === undefined) return "Package access unavailable"
        return packageTypes[permission] ? "" : "Upgrade your package"
    }

    const renderPackageAccessMessage = (permission) => {
        const message = getPackageAccessMessage(permission)
        return message ? <div className="option_inner_popup"><p>{message}</p></div> : null
    }


    const handleChange = (element, index) => {
        if (isNaN(element.value)) return false;
        setAdminPassword([...adminPassword.map((d, idx) => (idx === index ? element.value : d))]);        
    };

    const handleKeyPress = (e, index) => {
        if(e.keyCode === 8){
            if(e.target.previousSibling){
                e.target.previousSibling.focus();
            }
        }
        else{
            if (e.target.nextSibling) {
                e.target.nextSibling.focus();
            }
        }
    }


    const handelEventOption = async (data) => {
        const someTruthy = Object.values(data).some(val => val === true);
        const password = adminPassword.join('')
        if (someTruthy) {
            await dispatch(eventOptionItems({ ...data, adminPassword }))
            setLoading(true)
            setSubmitError("")

            try {
                const res = await http.post("event-option", { ...data, password, eventId })
                const dataItem = res?.data?.event_option || data;
                if (dataItem.social_media === true) { history.push('/event/social', eventId) }
                else if (dataItem.gif === true) { history.push('/event/gif', eventId) }
                else if (dataItem.brust_gif === true) { history.push('/event/brust-gif', eventId) }
                else if (dataItem.email === true) { history.push('/event/email', eventId) }
                else if (dataItem.text_messaging === true) { history.push('/event/sms', eventId) }
                else if (dataItem.digital_props === true) { history.push('/event/digital-prop', eventId) }
                else if (dataItem.water_mark === true) { history.push('/event/custom-branding', eventId) }
                else if (dataItem.microsite === true) { history.push('/event/microsite', eventId) }
                else if (dataItem.frame_option === true) { history.push('/event/frame', eventId) }
                else if (dataItem.video_frame_option === true) { history.push('/event/video-frame', eventId) }
                else if (dataItem.boomerang_frame_option === true) { history.push('/event/boomerang-frame', eventId) }
                else if (dataItem.incentive_offer === true) { history.push('/event/incentive-offer', eventId) }
                else if (dataItem.filters === true) { history.push('/event/filter', eventId) }
            } catch (error) {
                setSubmitError("Unable to save event options. Please try again.")
            } finally {
                setLoading(false)
            }
        }
        else {
            setTemplateErr(true)
        }
    }

    const saveAsDraft = () => {
        handleSubmit(async (data) => {
            const password = adminPassword.join('')
            await dispatch(eventOptionItems({ ...data, adminPassword }))
            setDraftLoading(true)
            setSubmitError("")

            try {
                await http.post("event-option", { ...data, password, eventId })
            } catch (error) {
                setSubmitError("Unable to save this draft. Please try again.")
            } finally {
                setDraftLoading(false)
            }

        })()
    }

    return (
        <Layout>
            <NewFormWizard />
            {/* <FormWizardChild /> */}
            <form onSubmit={handleSubmit(handelEventOption)}>
                <section className="mt-5">


                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="px-2 card">
                                <div className="py-5 text-center border-bottom">
                                    <h4 className="text-primary display-4 event-form-title">Event Options</h4>
                                    <span className="text-secondary">Select the features you want active.</span>
                                </div>
                                <div className="card-body">
                                    <p className={`pt-2 mb-0 text-danger font-weight-bold text-center fade ${emailTemplateErr ? 'show' : 'hide'}`}>Choose any option</p>
                                    <div className="pt-5 select__photo--area">
                                        <div className="flex-wrap d-flex justify-content-center">

                                            {feature.sharing === true && (<>
                                                <div className="photo__booth__area_checkbox">
                                                    <label className="option_item">
                                                        <input type="checkbox" className="checkbox" value="" {...register("social_media")} />
                                                        <div className="option_inner photo__booth">
                                                            <div className="tick-mark"></div>
                                                            <div className="icon">
                                                                <FaInstagram size={25} color={'#fff'} />
                                                            </div>
                                                            <p className="mt-2 mb-0 text-white">Social</p>
                                                        </div>
                                                    </label>
                                                </div>
                                            </>)}

                                            {feature.three_in_one === true && (<>
                                                <div className="photo__booth__area_checkbox">
                                                    <label className="option_item">
                                                        <input type="checkbox" className="checkbox" value="" {...register("gif")} />
                                                        <div className="option_inner photo__booth">
                                                            <div className="tick-mark"></div>
                                                            <div className="icon">
                                                                <AiOutlineFileGif size={25} color={'#fff'} />
                                                            </div>
                                                            <p className="mt-2 mb-0 text-white">3 in 1 Animation</p>
                                                        </div>
                                                    </label>
                                                </div>
                                                <div className="photo__booth__area_checkbox">
                                                    <label className="option_item">
                                                        <input type="checkbox" className="checkbox" value="" {...register("brust_gif")} />
                                                        <div className="option_inner photo__booth">
                                                            <div className="tick-mark"></div>
                                                            <div className="icon">
                                                                <ImFilm size={25} color={'#fff'} />
                                                            </div>
                                                            <p className="mt-2 mb-0 text-white">Speed Burst</p>
                                                        </div>
                                                    </label>
                                                </div>
                                            </>)}

                                            {feature.sharing === true && (<>
                                                <div className="photo__booth__area_checkbox">
                                                    <label className="option_item">
                                                        <input
                                                            type="checkbox"
                                                            className="checkbox"
                                                            disabled={!hasPackageAccess("email")}
                                                            value="" {...register("email")} />
                                                        <div className={`option_inner photo__booth ${hasPackageAccess("email") ? '' : 'disable-item'}`}>
                                                            <div className="tick-mark"></div>
                                                            <div className="icon">
                                                                <HiOutlineMail size={25} color={'#fff'} />
                                                            </div>
                                                            <p className="mt-2 mb-0 text-white">Email</p>


                                                        </div>
                                                        {renderPackageAccessMessage("email")}
                                                    </label>
                                                </div>

                                                <div className="photo__booth__area_checkbox">
                                                    <label className="option_item">
                                                        <input
                                                            type="checkbox"
                                                            className="checkbox"
                                                            disabled={!hasPackageAccess("text_messaging")}
                                                            value="" {...register("text_messaging")} />
                                                        <div className={`option_inner photo__booth ${hasPackageAccess("text_messaging") ? '' : 'disable-item'}`}>
                                                            <div className="tick-mark"></div>
                                                            <div className="icon">
                                                                <FiSmartphone size={25} color={'#fff'} />
                                                            </div>
                                                            <p className="mt-2 mb-0 text-white">SMS Sharing</p>
                                                        </div>
                                                        {renderPackageAccessMessage("text_messaging")}
                                                    </label>
                                                </div>
                                            </>)}

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox" value="" {...register("digital_props")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <GiDigitalTrace size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Props</p>
                                                    </div>
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input
                                                        type="checkbox"
                                                        disabled={!hasPackageAccess("custom_branding")}
                                                        className="checkbox"
                                                        value="" {...register("water_mark")} />
                                                    <div
                                                        className={
                                                            `option_inner photo__booth ${hasPackageAccess("custom_branding") ? '' : 'disable-item'}`
                                                        }>
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <FaRegClosedCaptioning size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Custom Branding</p>
                                                    </div>
                                                    {renderPackageAccessMessage("custom_branding")}
                                                </label>
                                            </div>

                                            {feature.sharing === true && (<>
                                                <div className="photo__booth__area_checkbox">
                                                    <label className="option_item">
                                                        <input
                                                            type="checkbox"
                                                            className="checkbox"
                                                            disabled={!hasPackageAccess("microsite")}
                                                            value="" {...register("microsite")} />
                                                        <div className={`option_inner photo__booth ${hasPackageAccess("microsite") ? '' : 'disable-item'}`}>
                                                            <div className="tick-mark"></div>
                                                            <div className="icon">
                                                                <MdDesktopWindows size={25} color={'#fff'} />
                                                            </div>
                                                            <p className="mt-2 mb-0 text-white">Social Gallery </p>
                                                        </div>
                                                        {renderPackageAccessMessage("microsite")}
                                                    </label>
                                                </div>
                                            </>)}
                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox" {...register("frame_option")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <BsAspectRatio size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 text-white">Selfie Frame</p>
                                                    </div>
                                                </label>
                                            </div>

                                            {feature.video === true && (<>
                                                <div className="photo__booth__area_checkbox">
                                                    <label className="option_item">
                                                        <input type="checkbox" className="checkbox" {...register("video_frame_option")} />
                                                        <div className="option_inner photo__booth">
                                                            <div className="tick-mark"></div>
                                                            <div className="icon">
                                                                <BsAspectRatio size={25} color={'#fff'} />
                                                            </div>
                                                            <p className="mt-2 text-white">Video Frames</p>
                                                        </div>
                                                    </label>
                                                </div>
                                            </>)}

                                            {feature.boomerang === true && (<>
                                                <div className="photo__booth__area_checkbox">
                                                    <label className="option_item">
                                                        <input type="checkbox" className="checkbox" {...register("boomerang_frame_option")} />
                                                        <div className="option_inner photo__booth">
                                                            <div className="tick-mark"></div>
                                                            <div className="icon">
                                                                <BsAspectRatio size={25} color={'#fff'} />
                                                            </div>
                                                            <p className="mt-2 text-white">Boomerang Frames</p>
                                                        </div>
                                                    </label>
                                                </div>
                                            </>)}

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox" value="" {...register("qr_code")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <ImQrcode size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">QR Code</p>
                                                    </div>
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input
                                                        type="checkbox"
                                                        className="checkbox"
                                                        disabled={!hasPackageAccess("incentive_offer")}
                                                        value="" {...register("incentive_offer")} />
                                                    <div className={`option_inner photo__booth ${hasPackageAccess("incentive_offer") ? '' : 'disable-item'}`}>
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <IoMdGift size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white"> Incentives & Offers</p>
                                                    </div>
                                                    {renderPackageAccessMessage("incentive_offer")}
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input
                                                        type="checkbox"
                                                        className="checkbox"
                                                        value="" {...register("filters")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <VscFileMedia size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Filters</p>
                                                    </div>
                                                </label>
                                            </div>

                                            {feature.data_capture === true && (<>
                                                <div className="photo__booth__area_checkbox">
                                                    <label className="option_item">
                                                        <input
                                                            type="checkbox"
                                                            className="checkbox"
                                                            disabled={!hasPackageAccess("form_builder")}
                                                            value="" {...register("form_builder")} />
                                                        <div className={`option_inner photo__booth ${hasPackageAccess("form_builder") ? '' : 'disable-item'}`}>
                                                            <div className="tick-mark"></div>
                                                            <div className="icon">
                                                                <AiFillEdit size={25} color={'#fff'} />
                                                            </div>
                                                            <p className="mt-2 mb-0 text-white">Form Builder</p>
                                                        </div>
                                                        {renderPackageAccessMessage("form_builder")}
                                                    </label>
                                                </div>
                                            </>)}


                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="my-5 col d-flex justify-content-between align-items-center">
                                            <div className="admin">
                                                <h2>Admin Password</h2>
                                                <p className="text-secondary">Keep your event safe by securing it with a numerical password.</p>

                                            </div>
                                            <div className="pin">
                                                <p className="mb-0 text-primary">Password</p>
                                                <div className="d-flex">
                                                    {adminPassword && adminPassword.map((data, index) => (
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="otp"
                                                            maxLength="1"
                                                            key={index}
                                                            value={data}
                                                            onKeyUp={e => handleKeyPress(e, index)}
                                                            onChange={e => handleChange(e.target, index)}
                                                            onFocus={e => e.target.select()}
                                                            required
                                                        />
                                                    )
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="my-5 row justify-content-center">
                        <div className="col-md-10">
                            {packageAccessStatus === "error" ? (
                                <div className="mb-3 alert alert-warning" role="alert">
                                    We could not verify your package access. Package-restricted options are temporarily unavailable.
                                    <button type="button" className="ml-3 btn btn-sm btn-outline-dark" onClick={() => setPackageRequestKey(key => key + 1)}>Retry</button>
                                </div>
                            ) : null}
                            {packageAccessStatus === "partial" ? (
                                <div className="mb-3 alert alert-warning" role="alert">Some package permissions could not be matched. Those options are temporarily unavailable.</div>
                            ) : null}
                            {submitError ? <div className="mb-3 alert alert-danger" role="alert">{submitError}</div> : null}
                            <button type="button" onClick={() => history.push('/event/feature')} className="float-left px-5 btn btn-outline-secondary radius-10">Back</button>
                            <button
                                type="submit"
                                disabled={loading || draftLoading || packageLoading}
                                className="float-right px-5 btn btn-primary radius-10"
                            >
                                {loading ?
                                    <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                    : "Next"
                                }
                            </button>

                            <button
                                type="button"
                                onClick={saveAsDraft}
                                disabled={loading || draftLoading || packageLoading}
                                className="float-right px-3 mr-2 btn btn-secondary radius-10"
                            >
                                {draftLoading ?
                                    <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                    : "Save as draft"
                                }
                            </button>

                        </div>
                    </div>
                </section>
            </form>
        </Layout>
    )
}

export default EventOption
